// src/i18nProvider.js
// Traducere in romana peste mesajele implicite din ra-language-english.
// Orice cheie neacoperita aici cade pe engleza, deci adaugarea e incrementala.
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";

const mesajeRo = {
    ...englishMessages,
    ra: {
        ...englishMessages.ra,
        action: {
            ...englishMessages.ra.action,
            add: "Adauga",
            add_filter: "Adauga filtru",
            back: "Inapoi",
            bulk_actions: "%{smart_count} selectate",
            cancel: "Renunta",
            clear_array_input: "Goleste lista",
            clear_input_value: "Sterge valoarea",
            clone: "Duplica",
            close: "Inchide",
            confirm: "Confirma",
            create: "Creeaza",
            create_item: "Creeaza %{item}",
            delete: "Sterge",
            edit: "Modifica",
            export: "Exporta",
            list: "Lista",
            refresh: "Reimprospateaza",
            remove: "Elimina",
            remove_all_filters: "Sterge toate filtrele",
            remove_filter: "Sterge filtrul",
            save: "Salveaza",
            search: "Cauta",
            select_all: "Selecteaza tot",
            select_row: "Selecteaza randul",
            show: "Vezi",
            sort: "Sorteaza",
            undo: "Anuleaza",
            unselect: "Deselecteaza",
            update: "Actualizeaza",
            move_up: "Muta mai sus",
            move_down: "Muta mai jos",
            open: "Deschide",
            toggle_theme: "Schimba tema",
challenge: "Verifica",
        },
        page: {
            ...englishMessages.ra.page,
            create: "Creeaza %{name}",
            dashboard: "Panou",
            edit: "%{name} %{recordRepresentation}",
            empty: "Inca nu exista %{name}.",
            error: "A aparut o eroare",
            invite: "Vrei sa adaugi una?",
            list: "%{name}",
            loading: "Se incarca",
            not_found: "Negasit",
            show: "%{name} %{recordRepresentation}",
        },
        navigation: {
            ...englishMessages.ra.navigation,
            clear_filters: "Sterge filtrele",
            no_filtered_results: "Niciun rezultat pentru filtrele alese.",
            no_results: "Niciun rezultat",
            page_out_of_boundaries: "Pagina %{page} nu exista",
            page_out_from_end: "Nu se poate merge dupa ultima pagina",
            page_out_from_begin: "Nu se poate merge inainte de pagina 1",
            page_range_info: "%{offsetBegin}-%{offsetEnd} din %{total}",
            page_rows_per_page: "Randuri pe pagina:",
            next: "Urmator",
            prev: "Anterior",
            previous: "Anterior",
            skip_nav: "Sari la continut",
        },
        message: {
            ...englishMessages.ra.message,
            about: "Despre",
            are_you_sure: "Sigur continui?",
            bulk_delete_content: "Sigur stergi acest element?|||Sigur stergi cele %{smart_count} elemente?",
            bulk_delete_title: "Sterge %{name}|||Sterge %{smart_count} %{name}",
            clear_array_input: "Sigur golesti lista?",
            delete_content: "Sigur stergi acest element?",
            delete_title: "Sterge %{name} #%{id}",
            details: "Detalii",
            error: "A aparut o eroare si cererea nu a putut fi finalizata.",
            invalid_form: "Formularul nu e valid. Verifica erorile.",
            loading: "Se incarca, asteapta putin",
            no: "Nu",
            not_found: "Ai gresit adresa sau ai urmat un link invalid.",
            yes: "Da",
            unsaved_changes: "Ai modificari nesalvate. Sigur pleci?",
        },
        input: {
            ...englishMessages.ra.input,
            file: { upload_several: "Trage fisierele aici sau apasa pentru a alege.", upload_single: "Trage fisierul aici sau apasa pentru a alege." },
            image: { upload_several: "Trage imaginile aici sau apasa pentru a alege.", upload_single: "Trage imaginea aici sau apasa pentru a alege." },
            references: { all_missing: "Datele referite nu au fost gasite.", many_missing: "Cel putin una dintre referinte nu mai e disponibila.", single_missing: "Referinta nu mai e disponibila." },
        },
        notification: {
            ...englishMessages.ra.notification,
            bad_item: "Element incorect",
            canceled: "Actiune anulata",
            created: "Element creat",
            data_provider_error: "Eroare la dataProvider. Verifica consola.",
            deleted: "Element sters |||| %{smart_count} elemente sterse",
            not_found: "Element negasit",
            http_error: "Eroare de comunicare cu serverul",
            i18n_error: "Traducerile pentru limba aleasa nu au putut fi incarcate",
            item_doesnt_exist: "Elementul nu exista",
            logged_out: "Sesiunea a expirat, autentifica-te din nou.",
            updated: "Element actualizat |||| %{smart_count} elemente actualizate",
            not_authorized: "Nu ai acces la aceasta resursa.",
        },
        validation: {
            ...englishMessages.ra.validation,
            email: "Adresa de email invalida",
            maxLength: "Cel mult %{max} caractere",
            maxValue: "Cel mult %{max}",
            minLength: "Cel putin %{min} caractere",
            minValue: "Cel putin %{min}",
            number: "Trebuie sa fie un numar",
            oneOf: "Trebuie sa fie una dintre valorile: %{options}",
            regex: "Formatul nu corespunde: %{pattern}",
            required: "Camp obligatoriu",
            unique: "Valoarea trebuie sa fie unica",
        },
        auth: {
            ...englishMessages.ra.auth,
            auth_check_error: "Autentifica-te pentru a continua",
            logout: "Iesire",
            password: "Parola",
            sign_in: "Autentificare",
            sign_in_error: "Autentificare esuata, incearca din nou.",
            user_menu: "Profil",
            username: "Utilizator",
        },
        sort: {
            ...englishMessages.ra.sort,
            sort_by: "Sorteaza dupa %{field} %{order}",
            ASC: "crescator",
            DESC: "descrescator",
        },
    },
    resources: {
        avansuri: { name: "Avansuri |||| Avansuri" },
        colaboratori: { name: "Colaborator |||| Colaboratori" },
        echipe: { name: "Echipa |||| Echipe" },
        evenimente: { name: "Eveniment |||| Evenimente" },
    },
};

export const i18nProvider = polyglotI18nProvider(() => mesajeRo, "ro", [
    { locale: "ro", name: "Romana" },
]);

export default i18nProvider;
